// src/modules/renters/constants/paymentConstants.ts

import { PAYMENT_STATUS } from "@/types/payment.type";

export const STATUS_LABELS = {
  [PAYMENT_STATUS.PENDING]: "Pendente",
  [PAYMENT_STATUS.RECEIVED]: "Recebido",
  [PAYMENT_STATUS.CONFIRMED]: "Confirmado",
  [PAYMENT_STATUS.OVERDUE]: "Atrasado",
  [PAYMENT_STATUS.REFUNDED]: "Reembolsado",
  [PAYMENT_STATUS.RECEIVED_IN_CASH]: "Recebido em dinheiro",
  [PAYMENT_STATUS.REFUND_REQUESTED]: "Reembolso solicitado",
  [PAYMENT_STATUS.REFUND_IN_PROGRESS]: "Reembolso em andamento",
  [PAYMENT_STATUS.CHARGEBACK_REQUESTED]: "Estorno solicitado",
  [PAYMENT_STATUS.CHARGEBACK_DISPUTE]: "Disputa de estorno",
  [PAYMENT_STATUS.AWAITING_CHARGEBACK_REVERSAL]: "Aguardando reversão de estorno",
  [PAYMENT_STATUS.DUNNING_REQUESTED]: "Cobrança negativada",
  [PAYMENT_STATUS.DUNNING_CANCELLED]: "Negativação cancelada",
  [PAYMENT_STATUS.DUNNING_RECEIVED]: "Negativação recebida",
  [PAYMENT_STATUS.Inativo]: "Removida"
};

export const TABLE_HEADERS = {
  "description": "Descrição",
  "value": "Valor",
  "dueDate": "Vencimento",
  "paymentDate": "Pagamento",
  "status": "Status",
  "invoiceUrl": "Link",
  "paymentViewed": "Visualização da Cobrança"
};

export const EMPTY_ACTION = { eventName: '', data: undefined };